import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import BrandLoader from './common/BrandLoader';

const PrivateRoute: React.FC = () => {
    const { currentUser, loading, needsOnboarding } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        // Cuentas nuevas → wizard de onboarding (antes iban al formulario completo
        // de Mi Negocio; ver docs/lealify-wizard-onboarding-plan.md)
        if (!loading && currentUser && needsOnboarding) {
            if (location.pathname !== '/onboarding') {
                navigate('/onboarding', { replace: true });
            }
        }
    }, [loading, currentUser, needsOnboarding, location.pathname, navigate]);

    if (loading) {
        return <BrandLoader fullScreen />;
    }

    if (!currentUser) {
        return <Navigate to="/login" replace />;
    }

    return <Outlet />;
};

export default PrivateRoute;
